import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@modules/shared.module';
import { ButtonCancelComponent } from '../button-cancel/button-cancel.component';

@Component({
  selector: 'app-button-delete-and-cancel',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, ButtonCancelComponent],
  template: `<app-button-cancel [isDialogClose]="isDialogClose" (click)="onCancelClick()"></app-button-cancel>
  <button mat-stroked-button color="warn" (click)="onDeleteClick()" [disabled]="disabled" name="Eliminar">
  <mat-icon>delete</mat-icon> Eliminar
</button>`,
  styleUrls: ['./button-delete-and-cancel.component.css'],
})
export class ButtonDeleteAndCancelComponent {
  @Input() disabled!: any
  @Input() isDialogClose: boolean = false
  @Output() deleteClicked: EventEmitter<void> = new EventEmitter();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter();

  constructor() {
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
  }

  onDeleteClick() {
    this.deleteClicked.emit();
  }

  onCancelClick() {
    this.cancelClicked.emit();
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
  }
}
